<template>
  <va-edit-layout>
    <doctors-form :id="id" :title="title" :item="item"></doctors-form>
  </va-edit-layout>
</template>

<script>
export default {
  props: ["id", "title", "item"],
};
</script>
